import { defineDomainTranslations } from './defineDomainTranslations';

const en = {
  'homeHub.announcement.description': 'Find your latest projects and start something new - all from Home.',
  'homeHub.announcement.dismiss': 'Dismiss',
  'homeHub.announcement.title': 'Say hello to Home page and Record video!',
  'homeHub.menu.delete': 'Delete',
  'homeHub.menu.download': 'Download video',
  'homeHub.menu.move': 'Move project',
  'homeHub.menu.rename': 'Rename',
  'homeHub.minutes.limitReached': 'Limit reached',
  'homeHub.minutes.plan': 'Plan',
  'homeHub.minutes.planTrial': 'Trial',
  'homeHub.minutes.recordingAvailable': 'Videos available for recording: {videos}',
  'homeHub.minutes.translation': 'Translation',
  'homeHub.minutes.translationAvailable': 'Videos available for translation: {videos}',
  'homeHub.minutes.upgrade': 'Upgrade plan',
  'homeHub.pageTitle': 'Home',
  'homeHub.recent.gridView': 'Grid view',
  'homeHub.recent.listView': 'List view',
  'homeHub.recent.loadError': 'We couldn’t load your recent projects.',
  'homeHub.recent.meta': '{type} · {time}',
  'homeHub.recent.moreActions': 'More actions for {name}',
  'homeHub.recent.noResults': 'No projects match your search',
  'homeHub.recent.restoringFiles':
    'Everything is safe. Your project is temporarily unavailable and will be ready in 3–4 hours.',
  'homeHub.recent.retry': 'Try again',
  'homeHub.recent.search': 'Search',
  'homeHub.recent.title': 'Recent',
  'homeHub.recent.translate': 'Translate',
  'homeHub.recent.translateItem': 'Translate {name}',
  'homeHub.recent.type.recording': 'Screen recording',
  'homeHub.recent.type.translation': 'Translation',
  'homeHub.record.description': 'Record your screen - AI cleans it up into a polished demo.',
  'homeHub.record.title': 'Record video',
  'homeHub.title': 'What would you like to work on today?',
  'homeHub.translate.description': 'Dubbing, subtitles and lip sync in 135+ languages.',
  'homeHub.translate.title': 'Translate video',
  'homeHub.trial.activeDescription':
    'Try Rask on your own video - dub, voice, and localize it - or record a new screen video.',
  'homeHub.trial.badge': '{count}-day trial',
  'homeHub.trial.endedBadge': 'Trial ended',
  'homeHub.trial.endedDescription': 'Upgrade to keep localizing and recording videos in Rask.',
  'homeHub.trial.upgradeNow': 'Upgrade now',
} as const;

type Translation = Record<keyof typeof en, string>;

const es = {
  'homeHub.announcement.description': 'Encuentra tus proyectos más recientes y empieza algo nuevo, todo desde Inicio.',
  'homeHub.announcement.dismiss': 'Cerrar',
  'homeHub.announcement.title': '¡Descubre la página de Inicio y la función Grabar vídeo!',
  'homeHub.menu.delete': 'Eliminar',
  'homeHub.menu.download': 'Descargar vídeo',
  'homeHub.menu.move': 'Mover proyecto',
  'homeHub.menu.rename': 'Cambiar nombre',
  'homeHub.minutes.limitReached': 'Límite alcanzado',
  'homeHub.minutes.plan': 'Plan',
  'homeHub.minutes.planTrial': 'Prueba',
  'homeHub.minutes.recordingAvailable': 'Vídeos disponibles para grabación: {videos}',
  'homeHub.minutes.translation': 'Traducción',
  'homeHub.minutes.translationAvailable': 'Vídeos disponibles para traducción: {videos}',
  'homeHub.minutes.upgrade': 'Mejorar el plan',
  'homeHub.pageTitle': 'Inicio',
  'homeHub.recent.gridView': 'Vista de cuadrícula',
  'homeHub.recent.listView': 'Vista de lista',
  'homeHub.recent.loadError': 'No hemos podido cargar tus proyectos recientes.',
  'homeHub.recent.meta': '{type} · {time}',
  'homeHub.recent.moreActions': 'Más acciones para {name}',
  'homeHub.recent.noResults': 'Ningún proyecto coincide con tu búsqueda',
  'homeHub.recent.restoringFiles':
    'Todo está a salvo. Tu proyecto no está disponible temporalmente y estará listo en 3–4 horas.',
  'homeHub.recent.retry': 'Reintentar',
  'homeHub.recent.search': 'Buscar',
  'homeHub.recent.title': 'Recientes',
  'homeHub.recent.translate': 'Traducir',
  'homeHub.recent.translateItem': 'Traducir {name}',
  'homeHub.recent.type.recording': 'Grabación de pantalla',
  'homeHub.recent.type.translation': 'Traducción',
  'homeHub.record.description': 'Graba tu pantalla y la IA la convierte en una demo impecable.',
  'homeHub.record.title': 'Grabar vídeo',
  'homeHub.title': '¿En qué quieres trabajar hoy?',
  'homeHub.translate.description': 'Doblaje, subtítulos y Lip-sync en más de 135 idiomas.',
  'homeHub.translate.title': 'Traducir vídeo',
  'homeHub.trial.activeDescription':
    'Prueba Rask con tu propio vídeo: dóblalo, ponle voz y localízalo, o graba un nuevo vídeo de tu pantalla.',
  'homeHub.trial.badge': 'Prueba de {count} días',
  'homeHub.trial.endedBadge': 'Prueba finalizada',
  'homeHub.trial.endedDescription': 'Mejora tu plan para seguir localizando y grabando vídeos en Rask.',
  'homeHub.trial.upgradeNow': 'Mejorar el plan ahora',
} satisfies Translation;

const pt = {
  'homeHub.announcement.description':
    'Encontre seus projetos mais recentes e comece algo novo, tudo direto da página Início.',
  'homeHub.announcement.dismiss': 'Fechar',
  'homeHub.announcement.title': 'Conheça a página Início e a opção Gravar vídeo!',
  'homeHub.menu.delete': 'Excluir',
  'homeHub.menu.download': 'Baixar vídeo',
  'homeHub.menu.move': 'Mover projeto',
  'homeHub.menu.rename': 'Renomear',
  'homeHub.minutes.limitReached': 'Limite atingido',
  'homeHub.minutes.plan': 'Plano',
  'homeHub.minutes.planTrial': 'Teste',
  'homeHub.minutes.recordingAvailable': 'Vídeos disponíveis para gravação: {videos}',
  'homeHub.minutes.translation': 'Tradução',
  'homeHub.minutes.translationAvailable': 'Vídeos disponíveis para tradução: {videos}',
  'homeHub.minutes.upgrade': 'Fazer upgrade do plano',
  'homeHub.pageTitle': 'Início',
  'homeHub.recent.gridView': 'Visualização em grade',
  'homeHub.recent.listView': 'Visualização em lista',
  'homeHub.recent.loadError': 'Não foi possível carregar seus projetos recentes.',
  'homeHub.recent.meta': '{type} · {time}',
  'homeHub.recent.moreActions': 'Mais ações para {name}',
  'homeHub.recent.noResults': 'Nenhum projeto corresponde à sua pesquisa',
  'homeHub.recent.restoringFiles':
    'Está tudo seguro. Seu projeto está temporariamente indisponível e ficará pronto em 3–4 horas.',
  'homeHub.recent.retry': 'Tentar novamente',
  'homeHub.recent.search': 'Pesquisar',
  'homeHub.recent.title': 'Recentes',
  'homeHub.recent.translate': 'Traduzir',
  'homeHub.recent.translateItem': 'Traduzir {name}',
  'homeHub.recent.type.recording': 'Gravação de tela',
  'homeHub.recent.type.translation': 'Tradução',
  'homeHub.record.description': 'Grave sua tela e a IA a transforma em uma demo impecável.',
  'homeHub.record.title': 'Gravar vídeo',
  'homeHub.title': 'Em que você quer trabalhar hoje?',
  'homeHub.translate.description': 'Dublagem, legendas e Lip-sync em mais de 135 idiomas.',
  'homeHub.translate.title': 'Traduzir vídeo',
  'homeHub.trial.activeDescription':
    'Experimente o Rask no seu próprio vídeo: faça a dublagem, a narração e a localização, ou grave um novo vídeo da sua tela.',
  'homeHub.trial.badge': 'Teste de {count} dias',
  'homeHub.trial.endedBadge': 'Teste encerrado',
  'homeHub.trial.endedDescription': 'Faça upgrade para continuar localizando e gravando vídeos no Rask.',
  'homeHub.trial.upgradeNow': 'Fazer upgrade agora',
} satisfies Translation;

const fr = {
  'homeHub.announcement.description':
    'Retrouvez vos projets récents et lancez-en de nouveaux, le tout depuis l’Accueil.',
  'homeHub.announcement.dismiss': 'Fermer',
  'homeHub.announcement.title': 'Découvrez la page Accueil et la fonctionnalité Enregistrer une vidéo !',
  'homeHub.menu.delete': 'Supprimer',
  'homeHub.menu.download': 'Télécharger la vidéo',
  'homeHub.menu.move': 'Déplacer le projet',
  'homeHub.menu.rename': 'Renommer',
  'homeHub.minutes.limitReached': 'Limite atteinte',
  'homeHub.minutes.plan': 'Offre',
  'homeHub.minutes.planTrial': 'Essai',
  'homeHub.minutes.recordingAvailable': "Vidéos disponibles pour l'enregistrement : {videos}",
  'homeHub.minutes.translation': 'Traduction',
  'homeHub.minutes.translationAvailable': 'Vidéos disponibles pour la traduction : {videos}',
  'homeHub.minutes.upgrade': 'Passer à une offre supérieure',
  'homeHub.pageTitle': 'Accueil',
  'homeHub.recent.gridView': 'Vue en grille',
  'homeHub.recent.listView': 'Vue en liste',
  'homeHub.recent.loadError': 'Impossible de charger vos projets récents.',
  'homeHub.recent.meta': '{type} · {time}',
  'homeHub.recent.moreActions': 'Plus d’actions pour {name}',
  'homeHub.recent.noResults': 'Aucun projet ne correspond à votre recherche',
  'homeHub.recent.restoringFiles':
    'Vos données sont en sécurité. Votre projet est temporairement indisponible et sera prêt dans 3 à 4 heures.',
  'homeHub.recent.retry': 'Réessayer',
  'homeHub.recent.search': 'Rechercher',
  'homeHub.recent.title': 'Récents',
  'homeHub.recent.translate': 'Traduire',
  'homeHub.recent.translateItem': 'Traduire {name}',
  'homeHub.recent.type.recording': 'Enregistrement d’écran',
  'homeHub.recent.type.translation': 'Traduction',
  'homeHub.record.description': 'Enregistrez votre écran : l’IA en fait une démo soignée.',
  'homeHub.record.title': 'Enregistrer une vidéo',
  'homeHub.title': 'Sur quoi souhaitez-vous travailler aujourd’hui ?',
  'homeHub.translate.description': 'Doublage, sous-titres et Lip-sync dans plus de 135 langues.',
  'homeHub.translate.title': 'Traduire une vidéo',
  'homeHub.trial.activeDescription':
    'Essayez Rask avec votre propre vidéo : doublez-la, ajoutez une voix off et adaptez-la, ou enregistrez une nouvelle vidéo de votre écran.',
  'homeHub.trial.badge': 'Essai de {count} jours',
  'homeHub.trial.endedBadge': 'Essai terminé',
  'homeHub.trial.endedDescription':
    'Passez à une offre supérieure pour continuer à adapter et enregistrer des vidéos dans Rask.',
  'homeHub.trial.upgradeNow': 'Passer à une offre supérieure',
} satisfies Translation;

const it = {
  'homeHub.announcement.description': 'Trova i tuoi progetti più recenti e inizia qualcosa di nuovo, tutto dalla Home.',
  'homeHub.announcement.dismiss': 'Chiudi',
  'homeHub.announcement.title': 'Scopri la pagina Home e la funzione Registra video!',
  'homeHub.menu.delete': 'Elimina',
  'homeHub.menu.download': 'Scarica video',
  'homeHub.menu.move': 'Sposta progetto',
  'homeHub.menu.rename': 'Rinomina',
  'homeHub.minutes.limitReached': 'Limite raggiunto',
  'homeHub.minutes.plan': 'Piano',
  'homeHub.minutes.planTrial': 'Prova',
  'homeHub.minutes.recordingAvailable': 'Video disponibili per la registrazione: {videos}',
  'homeHub.minutes.translation': 'Traduzione',
  'homeHub.minutes.translationAvailable': 'Video disponibili per la traduzione: {videos}',
  'homeHub.minutes.upgrade': 'Passa a un piano superiore',
  'homeHub.pageTitle': 'Home',
  'homeHub.recent.gridView': 'Vista a griglia',
  'homeHub.recent.listView': 'Vista a elenco',
  'homeHub.recent.loadError': 'Impossibile caricare i tuoi progetti recenti.',
  'homeHub.recent.meta': '{type} · {time}',
  'homeHub.recent.moreActions': 'Altre azioni per {name}',
  'homeHub.recent.noResults': 'Nessun progetto corrisponde alla ricerca',
  'homeHub.recent.restoringFiles':
    'È tutto al sicuro. Il tuo progetto è temporaneamente non disponibile e sarà pronto tra 3–4 ore.',
  'homeHub.recent.retry': 'Riprova',
  'homeHub.recent.search': 'Cerca',
  'homeHub.recent.title': 'Recenti',
  'homeHub.recent.translate': 'Traduci',
  'homeHub.recent.translateItem': 'Traduci {name}',
  'homeHub.recent.type.recording': 'Registrazione dello schermo',
  'homeHub.recent.type.translation': 'Traduzione',
  'homeHub.record.description': 'Registra lo schermo: l’IA lo trasforma in una demo curata.',
  'homeHub.record.title': 'Registra video',
  'homeHub.title': 'Su cosa vuoi lavorare oggi?',
  'homeHub.translate.description': 'Doppiaggio, sottotitoli e lip-sync in oltre 135 lingue.',
  'homeHub.translate.title': 'Traduci video',
  'homeHub.trial.activeDescription':
    'Prova Rask con il tuo video: doppialo, dagli una voce e localizzalo, oppure registra un nuovo video dello schermo.',
  'homeHub.trial.badge': 'Prova di {count} giorni',
  'homeHub.trial.endedBadge': 'Prova terminata',
  'homeHub.trial.endedDescription':
    'Passa a un piano superiore per continuare a localizzare e registrare video in Rask.',
  'homeHub.trial.upgradeNow': 'Fai l’upgrade ora',
} satisfies Translation;

const ru = {
  'homeHub.announcement.description':
    'Находите последние проекты и начинайте что-то новое — всё на странице «Главная».',
  'homeHub.announcement.dismiss': 'Закрыть',
  'homeHub.announcement.title': 'Встречайте: страница «Главная» и «Запись видео»!',
  'homeHub.menu.delete': 'Удалить',
  'homeHub.menu.download': 'Скачать видео',
  'homeHub.menu.move': 'Переместить проект',
  'homeHub.menu.rename': 'Переименовать',
  'homeHub.minutes.limitReached': 'Лимит исчерпан',
  'homeHub.minutes.plan': 'Тариф',
  'homeHub.minutes.planTrial': 'Пробный период',
  'homeHub.minutes.recordingAvailable': 'Доступно видео для записи: {videos}',
  'homeHub.minutes.translation': 'Перевод',
  'homeHub.minutes.translationAvailable': 'Доступно видео для перевода: {videos}',
  'homeHub.minutes.upgrade': 'Улучшить тариф',
  'homeHub.pageTitle': 'Главная',
  'homeHub.recent.gridView': 'Плитка',
  'homeHub.recent.listView': 'Список',
  'homeHub.recent.loadError': 'Не удалось загрузить недавние проекты.',
  'homeHub.recent.meta': '{type} · {time}',
  'homeHub.recent.moreActions': 'Другие действия: {name}',
  'homeHub.recent.noResults': 'По вашему запросу проектов не найдено',
  'homeHub.recent.restoringFiles': 'Всё в сохранности. Проект временно недоступен и будет готов через 3–4 часа.',
  'homeHub.recent.retry': 'Повторить',
  'homeHub.recent.search': 'Поиск',
  'homeHub.recent.title': 'Недавние',
  'homeHub.recent.translate': 'Перевести',
  'homeHub.recent.translateItem': 'Перевести «{name}»',
  'homeHub.recent.type.recording': 'Запись экрана',
  'homeHub.recent.type.translation': 'Перевод',
  'homeHub.record.description': 'Запишите экран — ИИ превратит запись в аккуратное демо.',
  'homeHub.record.title': 'Записать видео',
  'homeHub.title': 'Над чем хотите поработать сегодня?',
  'homeHub.translate.description': 'Дубляж, субтитры и липсинк более чем на 135 языках.',
  'homeHub.translate.title': 'Перевести видео',
  'homeHub.trial.activeDescription':
    'Попробуйте Rask на своём видео: дубляж, озвучка и локализация — или запишите новое видео с экрана.',
  'homeHub.trial.badge': 'Пробный период на {count} дн.',
  'homeHub.trial.endedBadge': 'Пробный период завершён',
  'homeHub.trial.endedDescription':
    'Перейдите на платный тариф, чтобы продолжить локализовать и записывать видео в Rask.',
  'homeHub.trial.upgradeNow': 'Перейти на платный тариф',
} satisfies Translation;

export const HOME_HUB_TRANSLATIONS = defineDomainTranslations({ en, es, fr, it, pt, ru });
